import React from 'react';
import { Link } from 'react-router-dom';
import { StoreIcon, LayoutTemplateIcon, BlocksIcon, CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    num: '01',
    slug: 'store-development',
    icon: <StoreIcon className="w-8 h-8 text-[#D4AF37]" data-id="element-293" />,
    title: 'Shopify Store Design',
    description: 'Launch a premium Shopify store designed to convert visitors into customers. We design fully branded ecommerce stores tailored to your niche and audience.',
    features: ['Premium UX/UI design', 'Conversion focused layouts', 'Mobile optimization', 'SEO friendly architecture', 'Payment & shipping setup']
  }, {
    num: '02',
    slug: 'theme-development',
    icon: <LayoutTemplateIcon className="w-8 h-8 text-[#D4AF37]" data-id="element-294" />,
    title: 'Shopify Theme Development',
    description: 'We build high performance Shopify themes designed for merchants and developers. Designed to meet the standards of the Shopify Theme Marketplace.',
    features: ['Speed optimization', 'Flexible customization', 'Scalable architecture', 'Modern UI design']
  }, {
    num: '03',
    slug: 'app-development',
    icon: <BlocksIcon className="w-8 h-8 text-[#D4AF37]" data-id="element-295" />,
    title: 'Shopify App Development',
    description: 'Powerful Shopify apps that extend store capabilities and unlock new features. All apps are designed for submission to the Shopify App Store.',
    features: ['Automation', 'Advanced analytics', 'Conversion optimization', 'Merchant productivity']
  }];
  return <section className="section-padding relative overflow-hidden" data-id="element-296">
      <div className="absolute top-0 right-0 w-[40rem] h-[40rem] bg-[#D4AF37]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-297" />

      <div className="text-center max-w-3xl mx-auto mb-16 relative z-10" data-id="element-298">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-299">Our Services</h2>
        <p className="text-xl text-gray-400" data-id="element-300">
          End-to-end Shopify solutions designed for scale and performance.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-301">
        {services.map((service, index) => <Link key={index} to={`/services/${service.slug}`} className="group glass-card p-8 flex flex-col h-full relative overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_10px_40px_-10px_rgba(212,175,55,0.15)]" data-id="element-302">
            {/* Gold top border accent on hover */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-gold opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-303" />

            {/* Number indicator */}
            <div className="absolute top-6 right-8 text-5xl font-bold text-white/5 select-none pointer-events-none group-hover:text-[#D4AF37]/10 transition-colors duration-300" data-id="element-304">
              {service.num}
            </div>

            <div className="w-16 h-16 rounded-2xl bg-[#D4AF37]/10 flex items-center justify-center mb-8 border border-[#D4AF37]/20 group-hover:scale-110 transition-transform duration-300" data-id="element-305">
              {service.icon}
            </div>
            <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-[#D4AF37] transition-colors" data-id="element-306">
              {service.title}
            </h3>
            <p className="text-gray-400 mb-8 leading-relaxed" data-id="element-307">
              {service.description}
            </p>
            <ul className="space-y-3 mb-8" data-id="element-308">
              {service.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-309">
                  <CheckCircle2Icon className="w-5 h-5 text-[#D4AF37] shrink-0 mt-0.5" data-id="element-310" />
                  <span className="text-gray-300 text-sm" data-id="element-311">{feature}</span>
                </li>)}
            </ul>
            <span className="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-[#D4AF37]" data-id="element-312">
              Learn more
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-313" />
            </span>
          </Link>)}
      </div>
    </section>;
}